import React, {Component} from "react";
import {connect} from "react-redux";
import SVGIcon from "../svg/SVGIcon";
import {withRouter} from 'react-router-dom';
import {setLogOut} from '../../helpers/security';

import "./ContactUs.css";

class ContactUs extends Component {

  constructor(props) {
    super(props);

    this.onClickLogout = this.onClickLogout.bind(this);
  }

  onClickLogout() {
    const {history} = this.props;
    setLogOut(()=>{
      history.push('?page=/login');
    });
  }

  render() {
    const link = "https://www.mckinsey.com/mgi/contact";
    return (
      <div id="fow-contact-us">
        <div className="fow-inner-container">
          <div className="fow-row fow-row-to-col">
            <div className="fow-col fow-col-1 fow-text-center">
              <h4 className="fow-font-title fow-font-size-xl fow-text-center">Connect with our Future of Work experts</h4>
              <div className="fow-contact-btn">
                <a href={link} target="_blank" rel="noopener noreferrer" className="fow-font-size-sm">
                  <SVGIcon name="world" width="20" height="20" fill="transparent" strokeWidth="2" />
                  <span className="fow-font-text fow-font-size-md fow-contact-label">Contact Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(null, null)(ContactUs));
